import { findDOMNode } from 'react-dom';
import { lifecycle } from 'recompose';

const ScrollToTop = (offset = 0) => lifecycle({
  componentDidMount() {
    const node = findDOMNode(this);
    if (!node || this.props.kiosk) return;

    // Wait for things to settle
    setTimeout(() => window.scrollTo(
      window.scrollX,
      (node.getBoundingClientRect().top + window.scrollY) + offset
    ));
  },
});

export default ScrollToTop;



// WEBPACK FOOTER //
// ./src/app/hoc/ScrollToTop.js